module.exports = __webpack_public_path__ + "img/smsCheck.4c965ced.svg";